import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { WeekdayToggleButtons } from '../../../components';
import FilterWrapper from '../filter-wrapper';


class WeekdayFilter extends Component {
  componentWillUnmount() {
    this.reset();
  }

  handleDaysOfWeek = (_, newDaysOfWeek) => {
    const { setFilterOption } = this.props;
    setFilterOption({ key: 'daysOfWeek', value: newDaysOfWeek });
  }

  reset = () => {
    const { setFilterOption } = this.props;
    setFilterOption({ key: 'daysOfWeek', value: null });
  }

  render() {
    const { selectedDaysOfWeek } = this.props;

    return (
      <FilterWrapper        
        title="Wochentag"
        resetFilter={this.reset}
        isResetDisabled={selectedDaysOfWeek.length === 0}
      >
        <WeekdayToggleButtons value={[...selectedDaysOfWeek]} onChange={this.handleDaysOfWeek} />
      </FilterWrapper>
    );
  }
}

WeekdayFilter.propTypes = {
  selectedDaysOfWeek: PropTypes.array,
  setFilterOption: PropTypes.func,
};

WeekdayFilter.defaultProps = {
  selectedDaysOfWeek: [],
  setFilterOption: () => {},
};

export default WeekdayFilter;
